module.exports = __webpack_public_path__ + "img/c05_buildingtechherbalmedicine_Normal_ua.096a0c1e.webp";